/* Align SALE tabs with the photograph inside each contained product image. */
(() => {
  const selector = '.iglam-polished .card-main .card__inner > .iglam-sale-tab';
  const frames = new Set();
  let scheduled = false;
  const canHover = window.matchMedia('(hover: hover) and (min-width: 768px)');

  function align(badge) {
    const frame = badge.parentElement;
    const primary = frame.querySelector('.card--image > img.featured-media');
    const secondary = frame.querySelector('.card-secondary-image img');
    const image = canHover.matches && frame.closest('.card-main').matches(':hover') && secondary ? secondary : primary;
    if (!image) return;
    const naturalWidth = image.naturalWidth || Number(image.getAttribute('width'));
    const naturalHeight = image.naturalHeight || Number(image.getAttribute('height'));
    const box = image.getBoundingClientRect();
    const parent = frame.getBoundingClientRect();
    if (!naturalWidth || !naturalHeight || !box.width || !box.height) return;
    const fit = getComputedStyle(image).objectFit;
    const scale = fit === 'cover' ? Math.max(box.width / naturalWidth, box.height / naturalHeight) : Math.min(box.width / naturalWidth, box.height / naturalHeight);
    const width = fit === 'fill' ? box.width : Math.min(box.width, naturalWidth * scale);
    const height = fit === 'fill' ? box.height : Math.min(box.height, naturalHeight * scale);
    // The storefront centres contained images; keep the tab inside the painted photo.
    badge.style.setProperty('--iglam-sale-left', `${Math.max(0, box.left - parent.left + (box.width - width) / 2).toFixed(2)}px`);
    badge.style.setProperty('--iglam-sale-top', `${Math.max(0, box.top - parent.top + (box.height - height) / 2 + height * 0.08).toFixed(2)}px`);
  }

  const resize = new ResizeObserver(schedule);
  function refresh() {
    scheduled = false;
    for (const frame of frames) {
      if (!frame.isConnected) { resize.unobserve(frame); frames.delete(frame); }
    }
    document.querySelectorAll(selector).forEach(badge => {
      const frame = badge.parentElement;
      if (!frames.has(frame)) { frames.add(frame); resize.observe(frame); }
      align(badge);
    });
  }
  function schedule() {
    if (!scheduled) { scheduled = true; requestAnimationFrame(refresh); }
  }
  document.addEventListener('load', event => {
    if (event.target.matches?.('.card--image img')) schedule();
  }, true);
  document.addEventListener('pointerover', event => {
    if (event.target.closest?.('.card-main')) schedule();
  });
  document.addEventListener('pointerout', event => {
    if (event.target.closest?.('.card-main')) schedule();
  });
  window.addEventListener('resize', schedule, { passive: true });
  new MutationObserver(schedule).observe(document.getElementById('MainContent') || document.body, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset', 'width', 'height']
  });
  schedule();
})();
